var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 15.5,
    fill: "#00E4AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7121 35.7046C18.7384 35.5536 17.1729 35.0138 16.0644 33.9053C14.7299 32.5709 14.2197 30.574 14.2197 28V22C14.2197 19.426 14.7299 17.4291 16.0644 16.0947C17.1729 14.9862 18.7384 14.4464 20.7121 14.2954C20.7924 14.266 20.8792 14.25 20.9697 14.25C21.0278 14.25 21.0843 14.2566 21.1385 14.2691C21.4085 14.2562 21.6856 14.25 21.9697 14.25H27.9697C30.5437 14.25 32.5406 14.7602 33.8751 16.0947C35.2095 17.4291 35.7197 19.426 35.7197 22V28C35.7197 30.574 35.2095 32.5709 33.8751 33.9053C32.5406 35.2398 30.5437 35.75 27.9697 35.75H21.9697C21.6856 35.75 21.4085 35.7438 21.1385 35.7309C21.0843 35.7434 21.0278 35.75 20.9697 35.75C20.8792 35.75 20.7924 35.734 20.7121 35.7046ZM20.2197 34.1468C18.784 33.9586 17.7965 33.5161 17.1251 32.8447C16.2095 31.9291 15.7197 30.426 15.7197 28V22C15.7197 19.574 16.2095 18.0709 17.1251 17.1553C17.7965 16.4839 18.784 16.0414 20.2197 15.8532V34.1468ZM21.7197 15.7518C21.802 15.7506 21.8853 15.75 21.9697 15.75H27.9697C30.3958 15.75 31.8989 16.2398 32.8144 17.1553C33.7299 18.0709 34.2197 19.574 34.2197 22V28C34.2197 30.426 33.7299 31.9291 32.8144 32.8447C31.8989 33.7602 30.3958 34.25 27.9697 34.25H21.9697C21.8853 34.25 21.802 34.2494 21.7197 34.2482V15.7518Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 15.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 27.5625L29.5596 25.0025L26.9996 22.4425",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.4987d4f45707f6713e99c8d21a6c6376.svg";
export { ForwardRef as ReactComponent };